import Button from '@carvana/ds-button';
import { breakpoint } from '@carvana/ds-styles';
import styled from 'styled-components';

const Content = styled.div<{ $wideOnDesktop?: boolean }>`
  width: 100%;
  max-width: 436px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin: 0;

  .tabStyle {
    width: 50%;
    margin-bottom: 32px;
  }

  .stateStyle {
    border-radius: 8px;
    box-sizing: border-box;
  }

  @media screen and (min-width: ${breakpoint.sm}) {
    max-width: ${({ $wideOnDesktop }) => ($wideOnDesktop ? '100%' : '436px')};

    .tabStyle {
      width: ${({ $wideOnDesktop }) => ($wideOnDesktop ? '24%' : '50%')};
    }
  }
`;

const SubmitInfo = styled(Button)<{ $wideOnDesktop?: boolean }>`
  margin: 24px 0;
  width: 100%;

  @media screen and (min-width: ${breakpoint.sm}) {
    width: ${({ $wideOnDesktop }) => ($wideOnDesktop ? 'auto' : '100%')};
  }
`;

const SubmitInfoDS = styled(Button)<{ $wideOnDesktop?: boolean }>`
  margin: 24px 0;
  width: 100%;

  @media screen and (min-width: ${breakpoint.sm}) {
    width: ${({ $wideOnDesktop }) => ($wideOnDesktop ? 'auto' : '100%')};
  }
`;

export { Content, SubmitInfo, SubmitInfoDS };
